"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputService = void 0;
var __1 = require("../");
var event_context_1 = require("./event.context");
var event_info_1 = require("./event.info");
var InputService = /** @class */ (function () {
    function InputService() {
        this.__priority = 100;
        this.isDebug = true;
        this.currentModifiers = { ctrl: false, shift: false, alt: false, meta: false };
        this.events = new Map();
        this.bound = false;
    }
    InputService.prototype.init = function () {
        if (this.bound) {
            return;
        }
        this.bound = true;
        var $window = __1.Services.Window.window;
        $window.document.addEventListener('keydown', this.onKeyDown.bind(this));
        $window.document.addEventListener('keyup', this.onKeyUp.bind(this));
        $window.addEventListener('focus', this.onWindowFocus.bind(this));
    };
    InputService.prototype.getContext = function () {
        return new event_context_1.InputEventBindContext(this);
    };
    InputService.prototype.onKeyDown = function (evt) {
        var code = evt.code;
        this.setModifiers(evt);
        var eventDescriptor = {
            code: code,
            modifiers: this.currentModifiers,
            eventType: 'keydown'
        };
        this.emit(eventDescriptor, evt);
    };
    InputService.prototype.onKeyUp = function (evt) {
        var code = evt.code;
        this.setModifiers(evt);
        var eventDescriptor = {
            code: code,
            modifiers: this.currentModifiers,
            eventType: 'keyup'
        };
        this.emit(eventDescriptor, evt);
    };
    /** Reset the current modifiers on window focus */
    InputService.prototype.onWindowFocus = function () {
        this.currentModifiers = { ctrl: false, shift: false, alt: false, meta: false };
    };
    InputService.prototype.on = function (ctx, eventDescriptor, callback) {
        var eventSymbol = Symbol();
        this.events.set(eventSymbol, new event_info_1.InputEventInfo(eventDescriptor, callback));
        return eventSymbol;
    };
    InputService.prototype.off = function (ctx, symbol) {
        return this.events.delete(symbol);
    };
    InputService.prototype.emit = function (eventDescriptor, evt) {
        this.events.forEach(function (event) {
            if (event.shouldTrigger(eventDescriptor)) {
                var eventData = {
                    event: evt,
                    descriptor: eventDescriptor
                };
                event.callback(eventData);
            }
        });
    };
    InputService.prototype.setModifiers = function (evt) {
        this.currentModifiers = {
            ctrl: evt.ctrlKey,
            shift: evt.shiftKey,
            alt: evt.altKey,
            meta: evt.metaKey
        };
    };
    return InputService;
}());
exports.InputService = InputService;
//# sourceMappingURL=input.service.js.map